"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVaultKeys = exports.addressParser = void 0;
const anchor_1 = require("@project-serum/anchor");
const fs = __importStar(require("fs"));
const address_json_1 = __importDefault(require("./address.json"));
const tokens_1 = require("./data/tokens");
function addressParser(params) {
    const tokenList = Object.keys(tokens_1.TOKENS);
    const x = {};
    for (const token of tokenList) {
        x[token] = {};
    }
    const json = address_json_1.default[params.group][params.name];
    Object.keys(json).forEach(function (key) {
        const value = json[key];
        if (typeof value === "object") {
            for (const token of tokenList) {
                if (value[token]) {
                    x[token][key] = new anchor_1.web3.PublicKey(value[token]);
                }
            }
        }
        else {
            for (const token of tokenList) {
                x[token][key] = new anchor_1.web3.PublicKey(value);
            }
        }
    });
    return x;
}
exports.addressParser = addressParser;
function updateVaultKeys(vaultKeys, name, tokenInput) {
    const params = groupNameToAddressParserParams(name);
    const json = address_json_1.default[params.group][params.name];
    Object.keys(json).forEach(function (key) {
        const targetPubkey = vaultKeys[tokenInput][key];
        if (targetPubkey) {
            if (typeof json[key] === "object") {
                json[key][tokenInput] = targetPubkey.toString();
            }
            else {
                json[key] = targetPubkey.toString();
            }
        }
    });
    const addressFile = __dirname + "/address.json";
    fs.writeFile(addressFile, JSON.stringify(address_json_1.default, null, 2), (error) => {
        if (error)
            throw new Error("Error wile saving keys file;" + error);
    });
    console.log("Updated address file");
}
exports.updateVaultKeys = updateVaultKeys;
function groupNameToAddressParserParams(name) {
    switch (name) {
        case "bestApy":
            return { group: "strategies", name: "bestApy" };
        default:
            throw new Error("Non-valid idl name: " + name);
    }
}
//# sourceMappingURL=addressParser.js.map